import React from 'react';
import { Grid, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { StatisticsCard } from '../../../@jumbo/components/Common';
import { formatNumber, formatCurrency } from './utils/formatDashboard';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import PeopleIcon from '@material-ui/icons/People';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import Skeleton from '@material-ui/lab/Skeleton';

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    color: theme.palette.common.white,
  },
  titleRoot: {
    fontSize: 12,
    fontWeight: 400,
    textTransform: 'uppercase',
    letterSpacing: 0.4,
  },
}));

const cardConfig = [
  {
    key: 'totalTransfers',
    title: 'Total Transfers',
    backgroundColor: '#7D38DF',
    icon: <SwapHorizIcon />,
    getValue: (s) => formatNumber(s?.totalTransfers),
  },
  {
    key: 'completedTransfers',
    title: 'Completed Transfers',
    backgroundColor: '#2E7D32',
    icon: <VerifiedUserIcon />,
    getValue: (s) => formatNumber(s?.completedTransfers),
  },
  {
    key: 'activeAgents',
    title: 'Active Agents',
    backgroundColor: '#1565C0',
    icon: <PeopleIcon />,
    getValue: (s) => formatNumber(s?.activeAgents),
  },
  {
    key: 'totalVolume',
    title: 'Total Volume',
    backgroundColor: '#5BA6D9',
    icon: <AccountBalanceWalletIcon />,
    getValue: (s) => formatCurrency(s?.totalVolume),
  },
  {
    key: 'pendingKyc',
    title: 'Pending KYC',
    backgroundColor: '#E65100',
    icon: <AssignmentIcon />,
    getValue: (s) => formatNumber(s?.pendingKyc),
  },
  {
    key: 'pendingTierUpgrades',
    title: 'Pending Tier Upgrades',
    backgroundColor: '#6A1B9A',
    icon: <TrendingUpIcon />,
    getValue: (s) => formatNumber(s?.pendingTierUpgrades),
  },
];

const SummaryStatsCards = ({ summary, loading }) => {
  const classes = useStyles();

  if (loading) {
    return cardConfig.map(({ key, title, backgroundColor }) => (
      <Grid item xs={12} sm={6} md={4} key={key}>
        <StatisticsCard
          className={classes.cardRoot}
          backgroundColor={backgroundColor}
          title={title}
          titleProps={{ variant: 'inherit', component: 'h4', className: classes.titleRoot }}
          amount={<Skeleton variant="text" width={80} />}
          description=""
        >
          <Box height={95} />
        </StatisticsCard>
      </Grid>
    ));
  }

  return cardConfig.map(({ key, title, backgroundColor, getValue }) => (
    <Grid item xs={12} sm={6} md={4} key={key}>
      <StatisticsCard
        className={classes.cardRoot}
        backgroundColor={backgroundColor}
        title={title}
        titleProps={{ variant: 'inherit', component: 'h4', className: classes.titleRoot }}
        amount={getValue(summary)}
        description=""
      >
        <Box height={95} />
      </StatisticsCard>
    </Grid>
  ));
};

export default SummaryStatsCards;
